import Flex from '@Components/Bases/Flex';
import { useGetEsgDataPlatform } from '@Domains/Esg/EsgDataPlatform';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useProgressBar } from 'src/Constant/ProgressBarsContext/ProgressBar.Context';
import { useEsgPlatformForm } from '../EsgPlatformFormProvider';
import { IEsgStatusFormValues } from '../EsgPlatformFormProvider/types';
import EsgPlatformScoreEn from './EsgPlatformScoreEn';
import EsgPlatformScoreTh from './EsgPlatformScoreTh';

const EsgPlatformScore = () => {
  const { id } = useParams();
  const { progressData } = useProgressBar();
  const { getValues } = useEsgPlatformForm();
  const {
    percentageTh,
    percentageEn,
    lastUpdateTh,
    lastUpdateEn,
    hasEsgPercentTh,
    hasEsgPercentEn,
  } = getValues('esgStatus') as IEsgStatusFormValues;

  const [{ data: esgSnapData, loading: esgSnapLoading }] =
    useGetEsgDataPlatform(id, true);

  const isPublished = Boolean(progressData?.summarizeReport.publishedDate);

  const {
    percentageTh: percentageThSnap,
    percentageEn: percentageEnSnap,
    lastUpdateTh: lastUpdateThSnap,
    lastUpdateEn: lastUpdateEnSnap,
  } = esgSnapData?.esgStatus || {};
  const thScore = isPublished ? percentageThSnap : percentageTh;
  const enScore = isPublished ? percentageEnSnap : percentageEn;
  const thUpdateDate = isPublished ? lastUpdateThSnap : lastUpdateTh;
  const enUpdateDate = isPublished ? lastUpdateEnSnap : lastUpdateEn;

  if (esgSnapLoading) {
    return (
      <Flex justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress size={50} />
      </Flex>
    );
  }

  return (
    <Box p={2} bgcolor={'white'}>
      <Flex flexDirection={'column'} gap={2}>
        <Box>
          <Box
            border={'1px solid rgba(169, 169, 169, 0.3)'}
            borderRadius={0.5}
            p={1}
            width={'100%'}
          >
            <Typography fontWeight={800}>
              สถานะการกรอกข้อมูล ESG (ไทย)
            </Typography>
          </Box>
          <EsgPlatformScoreTh
            esgScore={thScore}
            esgUpdateDate={thUpdateDate}
            hasPercentTh={hasEsgPercentTh}
          />
        </Box>

        {process.env.REACT_APP_ENABLED_ESG_DATA_PLATFORM_EN === 'true' && (
          <Box>
            <Box
              border={'1px solid rgba(169, 169, 169, 0.3)'}
              borderRadius={0.5}
              p={1}
              width={'100%'}
            >
              <Typography fontWeight={800}>
                สถานะการกรอกข้อมูล ESG (อังกฤษ)
              </Typography>
            </Box>
            <EsgPlatformScoreEn
              esgScore={enScore}
              esgUpdateDate={enUpdateDate}
              hasPercentEn={hasEsgPercentEn}
            />
          </Box>
        )}
      </Flex>
    </Box>
  );
};
export default EsgPlatformScore;
